export default {
  text: '#282e37',
  primary: '#249c2e',
  secondary: '#282e37',
  background: '#fdfdfd',
  backgroundSecondary: '#e2ffe4',
  light: '#fdfdfd',
  dark: '#020303'
}
